import Alpine from 'alpinejs';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import GLightbox from 'glightbox';
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

// Initialize GLightbox
let lightbox = GLightbox({
    selector: '.gl-gallery',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});

// Function to reinitialize GLightbox for dynamically loaded content
function reinitializeGLightbox() {
    if (lightbox) {
        lightbox.destroy();
    }
    lightbox = GLightbox({
        selector: '.gl-gallery',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });
    console.log('GLightbox reinitialized');
}

// Make reinitializeGLightbox available globally
window.reinitializeGLightbox = reinitializeGLightbox;

// Parts Search functionality
document.addEventListener('DOMContentLoaded', function() {
    const partsSearch = document.getElementById('partsSearch');
    const partsTableBody = document.getElementById('partsTableBody');
    const noResults = document.getElementById('noResults');
    
    if (partsSearch && partsTableBody) {
        partsSearch.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase().trim();
            const partRows = partsTableBody.querySelectorAll('.part-row');
            let visibleCount = 0;
            
            partRows.forEach(row => {
                const title = row.getAttribute('data-title') || '';
                const partNo = row.getAttribute('data-partno') || '';
                const description = row.getAttribute('data-description') || '';
                
                const matches = title.includes(searchTerm) || 
                              partNo.includes(searchTerm) || 
                              description.includes(searchTerm);
                
                if (matches) {
                    row.style.display = '';
                    visibleCount++;
                } else {
                    row.style.display = 'none';
                }
            });
            
            // Show/hide no results message
            if (visibleCount === 0 && searchTerm !== '') {
                if (noResults) noResults.classList.remove('hidden');
            } else {
                if (noResults) noResults.classList.add('hidden');
            }
        });
    }
});

const hamburger = document.querySelector(".hamburger");
if (hamburger) {
	hamburger.addEventListener("click", (e) => {
		document.querySelector(".navigation").classList.toggle('hidden');
		hamburger.querySelector('.icon-close').classList.toggle('opacity-0');
		hamburger.querySelector('.icon-menu').classList.toggle('opacity-0');
	}, false);
}

 // Swiper: Slider
const heroSwiper = new Swiper('.hero_carousel', {
	loop: false,
	slidesPerView: 1,
	paginationClickable: true,
	pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
	autoplay: {
		delay: 10000,
		disableOnInteraction: false
	},
});

// Testimonail Slider
const testimonailSwiper = new Swiper('.testimonial_carousel', {
	loop: true,
	slidesPerView: 1,
	autoHeight: true,
	// paginationClickable: true,
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
	pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

// product slider
var swiper = new Swiper(".product_slider", {
	slidesPerView: 4,
	spaceBetween: 0,
	gap: 0,
	breakpoints: {
	  	320:{
			slidesPerView: 1,
			spaceBetween: 0,
	  	},
  		640: {
			slidesPerView: 2,
			spaceBetween: 0,
  		},
  		992: {
			slidesPerView: 4,
			spaceBetween: 0,
  		},
	},
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

// Machine Product Gallery Slider
const machineProductGallery = new Swiper('.swiper-container', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    }
});

const lightboxVideo = GLightbox({
	selector: '.gl-video'
});

// Initialize GLightbox for images
const lightboxImages = GLightbox({
	selector: '.glightbox'
});

// smooth Scroll
const links = document.querySelectorAll('.js-scroll');
links.forEach(function (el) {
    el.addEventListener('click', smoothScroll)
});

function smoothScroll(e) {

    e.preventDefault();

    const link = this.getAttribute("href");

    const offsetTop = document.querySelector(link).scrollIntoView({
     	behavior: 'smooth'
	});
}

// border active on sub menu
const mapFixed = document.getElementById('google-map');
if(mapFixed)
{
	const section = document.querySelectorAll(".scroll");
	const subNavbar = document.querySelector('.sub-navbar');
	var fixed = null ;
	var fixed2 = null;
	if (subNavbar) {
		fixed = subNavbar.offsetTop;
	}

	document.addEventListener("scroll", () => {
	  	if (subNavbar) {
			if (window.pageYOffset >= fixed) {
				subNavbar.classList.add('lg:fixed');
			}else{
				subNavbar.classList.remove('lg:fixed');
			}
		}
		if (mapFixed) {
			if (window.pageYOffset >= mapFixed.offsetTop && window.pageYOffset + window.innerHeight - (mapFixed.offsetTop + mapFixed.scrollHeight) <= 0) {
				mapFixed.querySelector('#fixed-map').classList.add('lg:!fixed', 'top-0');
			}else if(window.pageYOffset + window.innerHeight - (mapFixed.offsetTop + mapFixed.scrollHeight) >= 0){
				mapFixed.querySelector('#fixed-map').classList.remove('lg:!fixed', 'top-0');
				mapFixed.querySelector('#fixed-map').classList.add('bottom-0', 'lg:absolute');
			}else{
				mapFixed.querySelector('#fixed-map').classList.remove('lg:!fixed');
			}
		}

	  	links.forEach(function(el){
	  		el.querySelector('.active-border').classList.remove('opacity-100');
	  	});

		section.forEach(function(el, index){
			if (el.offsetTop - 65 <= window.pageYOffset && (el.offsetTop + el.offsetHeight) - 65 > window.pageYOffset) {
				document.querySelector('a[href*=' + el.id + ']').querySelector('.active-border').classList.add('opacity-100');
			}
		});
	});

	// hide show for reseller
	let continentForm = document.querySelector("#continent-form #continent");
	let newMarkers;
	if (continentForm) {
		continentForm.addEventListener("change", (el)=>{
			// scroll top map div
			if (screen.width > 1023) {
				const scrollTop = el.target.scrollIntoView({
			     	behavior: "smooth"
				});
			}

			el.target.parentElement.parentElement.parentElement.querySelectorAll('[data-continent]').forEach(function(e){
				if (el.target.value) {
					e.classList.add('hidden');
				}else{
					e.classList.remove('hidden');
				}
			});

			if (el.target.value) {
				el.target.parentElement.parentElement.parentElement.querySelector('[data-continent="' + el.target.value + '"]').classList.remove("hidden");
			}

			initMap(el.target.value);
		});
	}

	// init Map
	let pushMarkers = [];
	let infoWindow = new google.maps.InfoWindow();
	let infoContent = {};

	function initMap(type) {

		let markerId = document.getElementById("map");
		let markers = markerId ? JSON.parse(markerId.dataset.markers) : '';
		let newMarkers = [];
		let bounds = new google.maps.LatLngBounds();
		const icon = {
		    url: '/assets/images/ge-pin.png', // url
		    scaledSize: new google.maps.Size(25, 35), // scaled size
		};

		const map = new google.maps.Map(markerId, {
	    	zoom: 8,
	    	minZoom: 2,
	    	restriction: {
		    	latLngBounds: {
		      		north: 85,
					south: -85,
					west: -180,
					east: 180
		    	},
		  	},
	  	});

		if (type) {
			for (var i = 0; i < markers.length; i++) {
				if (markers[i].type == type) {
					newMarkers.push(markers[i])
				}
			}
			markers = newMarkers;
		}

	  	markers.forEach(setMarkers);

		function setMarkers(item, index) {
			var myLatlng = new google.maps.LatLng(item.lat, item.lng);
			var marker = new google.maps.Marker({
			    position: myLatlng,
				title: item.key,
				icon: icon
			});

	    	infoContent[item.key] = `<div class="shadow-[0px_0px_20px_-8px]">
				<h4 class="lg:text-lg text-sm font-serif text-black mb-2">${item.title}</h4>
					<p class="w-full mb-4">${item.address}</p>
				<div class="flex flex-wrap items-center gap-5">
					<a href="${item.phone}" class="hover:text-blue-500 focus:outline-0">
						<svg class="icon--phone icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--phone" aria-labelledby="title__phone">
								<title id="title__phone"></title>
							</use>
						</svg>
					</a>
					<a href="javascript:;" data-email="${item.email}" data-title="${item.title}" onclick="toggleModal(); resellerForm(this);" class="trigger-form hover:text-blue-500">
						<svg class="icon--email icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--email" aria-labelledby="title__email">
								<title id="title__email"></title>
							</use>
						</svg>
					</a>
					<a href="${item.website}" target="_blank" rel="noopener" class="hover:text-blue-500">
						<svg class="icon--globe icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--globe" aria-labelledby="title__globe">
								<title id="title__globe"></title>
							</use>
						</svg>
					</a>
				</div>
			</div>`;

			google.maps.event.addListener(marker, 'click', (function(marker, i) {
	            return function() {
			        infoWindow.setContent(`<div class="shadow-[0px_0px_20px_-8px]">
						<h4 class="lg:text-lg text-sm font-serif text-black mb-2">${item.title}</h4>
							<p class="w-full mb-4">${item.address}</p>
						<div class="flex flex-wrap items-center gap-5">
							<a href="${item.phone}" class="hover:text-blue-500 focus:outline-0">
								<svg class="icon--phone icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--phone" aria-labelledby="title__phone">
										<title id="title__phone"></title>
									</use>
								</svg>
							</a>
							<a href="javascript:;" data-email="${item.email}" data-title="${item.title}" onclick="toggleModal(); resellerForm(this);" class="trigger-form hover:text-blue-500">
								<svg class="icon--email icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--email" aria-labelledby="title__email">
										<title id="title__email"></title>
									</use>
								</svg>
							</a>
							<a href="${item.website}" target="_blank" rel="noopener" class="hover:text-blue-500">
								<svg class="icon--globe icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--globe" aria-labelledby="title__globe">
										<title id="title__globe"></title>
									</use>
								</svg>
							</a>
						</div>
					</div>`);
	                infoWindow.open(map, marker);
	                if (screen.width > 1023) {
	                	removeBg();
	                	let element = document.querySelector("[data-markerId='" + marker.title + "']");
	                	element.classList.add("bg-blue-100");
		                element.scrollIntoView({
					     	behavior: "smooth"
						});
					}
	            }
	        })(marker));
			infoWindow.addListener('closeclick', ()=>{
			  	removeBg()
			});
			function removeBg(){
				document.querySelectorAll(".hover-open-infowindow").forEach(function(el){
	        		el.classList.remove("bg-blue-100");
	        	});
			}
			// To add the marker to the map, call setMap();
			var zoomChangeBoundsListener =
		    google.maps.event.addListener(map, 'bounds_changed', function(event) {
		        google.maps.event.removeListener(zoomChangeBoundsListener);
		        map.setZoom( Math.min( 16, map.getZoom() ) );
		    });
			bounds.extend(myLatlng);
			marker.setMap(map);
			pushMarkers.push(marker);
			map.fitBounds(bounds);
		}
	}

	window.onload = function() {
	    // let's go!
		if(document.getElementById("map")) {
			initMap();
		}
	}

	// hover listing to show info popup on marker
	document.querySelectorAll(".hover-open-infowindow").forEach(function(el){
		el.addEventListener("mouseenter", function(event) {
			for ( var i = 0; i< pushMarkers.length; i++) {
		        if (this.dataset.markerid === pushMarkers[i].title) {
		        	infoWindow.setContent(infoContent[this.dataset.markerid]);
		           	infoWindow.open(map, pushMarkers[i]);

		        }
		    }
		});

		el.addEventListener("mouseleave", function(event) {
			for ( var i = 0; i< pushMarkers.length; i++) {
		        if (this.dataset.markerid === pushMarkers[i].title) {
		           	infoWindow.close(map, pushMarkers[i]);
		        }
		    }
		});
	});
}

/*let playButton = document.querySelectorAll(".play-video");

playButton.forEach(function(el){
	el.addEventListener("click", () =>{
		el.parentElement.querySelector('iframe').classList.remove('hidden');
		el.parentElement.querySelector('iframe').src += '&autoplay=1'
		el.classList.add('hidden')
		el.parentElement.querySelector('picture').classList.add('hidden')
	});
});*/

/**
 * QR Code Clipboard Function
 * Allows copying QR code images to clipboard
 */
async function copyQrToClipboard(imgId, btn) {
    console.log('copyQrToClipboard called with:', imgId, btn);
    
    if (!navigator.clipboard || !window.ClipboardItem) {
        console.error('Clipboard API not supported');
        alert('Clipboard image copy not supported in this browser.');
        return;
    }
    
    const img = document.getElementById(imgId);
    if (!img) {
        console.error('Image element not found:', imgId);
        return;
    }
    
    console.log('Found image:', img.src);
    btn.disabled = true;
    
    try {
        const res = await fetch(img.src);
        const blob = await res.blob();
        await navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
        btn.textContent = 'Copied!';
        setTimeout(() => { btn.textContent = 'Copy QR'; btn.disabled = false; }, 1500);
        console.log('QR code copied successfully');
    } catch (err) {
        console.error('Failed to copy QR code:', err);
        alert('Failed to copy QR code.');
        btn.disabled = false;
    }
}

// Make the function globally available for onclick handlers
window.copyQrToClipboard = copyQrToClipboard;

// Debug: Log when the function is loaded
// console.log('QR copy function loaded and available globally');

/**
 * Parts Modal Functionality
 * Handles the custom modal for displaying part details with navigation
 */
let currentPartIndex = 0;
let totalParts = 0;

function openPartPopup(partId, title, partNo, description, machineType, imageUrl) {
    // Get total parts count
    const partElements = document.querySelectorAll('.part-content');
    totalParts = partElements.length;
    
    if (totalParts === 0) return;
    
    // Find the part index by title
    currentPartIndex = Array.from(partElements).findIndex(part => 
        part.querySelector('h2') && part.querySelector('h2').textContent === title
    );
    
    if (currentPartIndex === -1) currentPartIndex = 0;
    
    // Show the selected part
    showPart(currentPartIndex);
    
    // Show the modal
    const modal = document.getElementById('partModal');
    if (modal) {
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    
    // Update navigation buttons
    updateNavigationButtons();
}

function showPart(index) {
    if (index < 0 || index >= totalParts) return;
    
    currentPartIndex = index;
    
    // Hide all parts
    document.querySelectorAll('.part-content').forEach(part => {
        part.classList.add('hidden');
    });
    
    // Show the selected part
    const partElements = document.querySelectorAll('.part-content');
    if (partElements[index]) {
        partElements[index].classList.remove('hidden');
    }
    
    // Update counter
    const counter = document.getElementById('partCounter');
    if (counter) {
        counter.textContent = `Part ${index + 1} of ${totalParts}`;
    }
    
    // Update navigation buttons
    updateNavigationButtons();
}

function showPreviousPart() {
    if (currentPartIndex > 0) {
        showPart(currentPartIndex - 1);
    }
}

function showNextPart() {
    if (currentPartIndex < totalParts - 1) {
        showPart(currentPartIndex + 1);
    }
}

function updateNavigationButtons() {
    const prevBtn = document.getElementById('prevPartBtn');
    const nextBtn = document.getElementById('nextPartBtn');
    
    if (!prevBtn || !nextBtn) return;
    
    // Previous button
    if (currentPartIndex <= 0) {
        prevBtn.disabled = true;
        prevBtn.classList.add('opacity-50', 'cursor-not-allowed');
    } else {
        prevBtn.disabled = false;
        prevBtn.classList.remove('opacity-50', 'cursor-not-allowed');
    }
    
    // Next button
    if (currentPartIndex >= totalParts - 1) {
        nextBtn.disabled = true;
        nextBtn.classList.add('opacity-50', 'cursor-not-allowed');
    } else {
        nextBtn.disabled = false;
        nextBtn.classList.remove('opacity-50', 'cursor-not-allowed');
    }
}

function closePartModal() {
    const modal = document.getElementById('partModal');
    if (modal) {
        modal.classList.add('hidden');
        document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Reset to first part
    currentPartIndex = 0;
    if (totalParts > 0) {
        showPart(0);
    }
}

// Initialize parts modal functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    // Add keyboard event listeners for modal navigation
    document.addEventListener('keydown', function(event) {
        const modal = document.getElementById('partModal');
        if (modal && !modal.classList.contains('hidden')) {
            if (event.key === 'Escape') {
                closePartModal();
            } else if (event.key === 'ArrowLeft') {
                showPreviousPart();
            } else if (event.key === 'ArrowRight') {
                showNextPart();
            }
        }
    });
    
    // Initialize total parts count
    const partElements = document.querySelectorAll('.part-content');
    totalParts = partElements.length;
    
    // Update counter on page load
    const counter = document.getElementById('partCounter');
    if (counter && totalParts > 0) {
        counter.textContent = `Part 1 of ${totalParts}`;
    }
});

// Make functions globally available for onclick handlers
window.openPartPopup = openPartPopup;
window.showPreviousPart = showPreviousPart;
window.showNextPart = showNextPart;
window.closePartModal = closePartModal;

/**
 * Alpine JS
 * Start Alpine after other setup
 */
window.Alpine = Alpine;
Alpine.start();

// Initialize Formie when Blitz injects dynamic content
['blitzload', 'afterBlitzInject', 'afterBlitzInjectAll'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
        if (window.Formie) {
            window.Formie.initForms();
        }
    });
});
